import type { User } from "../types";

type AuthRoutingUser = Pick<
  User,
  "role" | "mustChangePassword" | "mfaEnabled"
>;

export function requiresStaffMfaSetup(user: AuthRoutingUser) {
  return user.role !== "LEARNER" && !user.mfaEnabled;
}

export function authenticatedDestination(
  user: AuthRoutingUser,
  requestedPath = "/",
) {
  if (user.mustChangePassword) return "/change-password";
  if (requiresStaffMfaSetup(user)) return "/mfa-setup";
  return requestedPath;
}
